import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MainMenuService } from '../main/objects/main-menu.service';
import { FlashService } from './flash.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
    
    constructor(private http: HttpClient, private flashService: FlashService) { }

    GetApplicationOptions(id) {
        var self = this;
        return this.http.get('/api/Home/ApplicationOptions?appId=' + id).toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    GetConstants() {
        var self = this;
        return this.http.get('/api/Home/GetConstants/').toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    RefreshAppOptionTiles(data) {
        var self = this;
        return this.http.post('/api/Home/RefreshTileContents', data).toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    private handleSuccess(res) {
        return { success: true, data: res};
    }

    private handleError(res) {
        this.flashService.Error(res.error.errors.toString(), false);
        return { success: false };
    }
}
